import { Icon } from "@iconify/react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <nav className="footer__container" aria-label="Links rápidos">
        <a
          className="footer__link"
          href="https://webapp.bateclick.com.br/home"
          target="_blank"
          rel="noreferrer"
        >
          <Icon icon="mdi:home" className="footer__icon" />
          <span>Início</span>
        </a>
        <a
          className="footer__link"
          href="https://webapp.bateclick.com.br/Acompanhamento2"
          target="_blank"
          rel="noreferrer"
        >
          <Icon icon="mdi:car-wrench" className="footer__icon" />
          <span>Reparo acompanhamento</span>
        </a>
      </nav>
    </footer>
  );
}

export default Footer;
